import type { ReactNode } from "react";
import { Menu, type MenuProps } from "react-aria-components";

export interface SimpleMenuProps<T> extends Omit<
  MenuProps<T>,
  "aria-label" | "children"
> {
  "aria-label": string;
  children: ReactNode;
}

export const SimpleMenu = <T extends object>({
  children,
  ...props
}: SimpleMenuProps<T>) => {
  return <Menu {...props}>{children}</Menu>;
};
